"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCarbonIntensity = void 0;
const getCarbonIntensity = (intensity, limits) => {
    if (intensity < (limits?.low ?? 25)) {
        return "low";
    }
    if (intensity < (limits?.medium ?? 70)) {
        return "medium";
    }
    return "high";
};
exports.getCarbonIntensity = getCarbonIntensity;
